import React, { useEffect, useState } from 'react'
import '../assets/main.css';
import '../assets/util.css';
import {Navigate} from 'react-router-dom'
import {connect} from 'react-redux'
import {userLogin} from './../actions/user'
import { Layout, Form, Input, Button,  notification  } from 'antd';



function Login(props) {

    const { userLogin } = props
    const [admission_no, setadmission_no] = useState('')
    const [passwd, setpasswd] = useState('')

      const onFinish = (values) => {
          let fd = new FormData()
          fd.append('admission_no', admission_no);
          fd.append('passwd', passwd);
          fd.append('cat', 'login');
          fd.append('table', 'students');
          userLogin(fd)   
      };
     
    
      const onFinishFailed = (errorInfo) => {
        openNotification(errorInfo)
      };

      const openNotification = (errorInfo) => {
        const args = {
          message: 'Error',
          description:
            errorInfo,
          duration: 0,
        };
        notification.open(args);
      };

      if(props.user.isAuthenticated === true)
      {
           return <Navigate to='/home' />
      }

      // if(props.user.isLogin === 1 || props.user.msg.length > 0)
      // {
      //    openNotification()
      // }
      
    
    return (
    <div className="limiter">
     
		<div className="container-login100">
      
			<div className="wrap-login100">
            <Form
            name="basic"
            className="login100-form validate-form"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            >
              <div style={{color:'red', fontSize:'12px'}}>
                  {props.user.msg}
            </div>
                <span className="login100-form-title p-b-43">
                <img 
                  height='60px'
                  className="imglogin1"
                  alt="school logo" 
                  src={process.env.REACT_APP_PICS} 
                  onError={(e)=>{
                    e.target.onerror=null; 
                    e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                  } }
                  />
             

						Student Login
				</span>
            <Form.Item
                label="Matric. Number"
                placeholder="SIL/EP1/2025/0001"
                name="username"
                value={admission_no}
                onChange= {(e)=>setadmission_no(e.target.value)}
                rules={[{ required: true, message: 'Pls. enter correctly eg. BBK/EP1/2025/0001' }]}
            >
                <Input 
                />
            </Form.Item>

            <Form.Item
                label="Phone Number"
                name="password"
                value={passwd}
                onChange= {(e)=>setpasswd(e.target.value)}
                rules={[{ required: true, message: 'Please input your password!' }]}
            >
                <Input.Password />
            </Form.Item>
            <div className="flex-sb-m w-full p-t-3 p-b-32">
						<div className="contact100-form-checkbox">
							<input className="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" />
							<label className="label-checkbox100" for="ckb1">
								Remember me
							</label>
						</div>
            

						<div>
							<a href="#" className="txt1">
								Forgot Password?
							</a>
						</div>
					</div>

            {/* <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
                <Checkbox>Remember me</Checkbox>
            </Form.Item> */}

            <Form.Item className="container-login100-form-btn" >
                <Button type="primary" htmlType="submit" className="login100-form-btn">
                Submit
                </Button>
            </Form.Item>
            </Form>


				<div className="login100-more" style={{backgroundImage:  `url(${process.env.PUBLIC_URL+'/asset/img/bg2.jpg'})`}}>
                <img 
                  height='100px'
                  className="imglogin"
                  alt="school logo" 
                  src={process.env.REACT_APP_SERVER_URL+ ''} 
                  onError={(e)=>{
                    e.target.onerror=null; 
                    e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                  } }
                  />
                  
				</div>
			</div>
		</div>
	</div>
    )
}

const mapStateToProps = (state) => ({
    user:state.userReducer
})

const mapDispatchToProps = {
    userLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



